// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featuresMargin{
  margin-top: 62px;
}
.calendexFeatureHeading {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  color: #554d89;
}

.calendexFeatureParagraph {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  /* or 150% */

  color: #716c80;
}

.btnReadMoreBoxCoustom {
  width: 153px;
  height: 50px;
  background: linear-gradient(26.57deg, #4d30ff 16.67%, #648fff 100%);
  border-radius: 40px;
}


.btnReadMoreTextCoustom{
    font-family: 'Poppins';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 24px;
text-align: center;
letter-spacing: 0.5px;
color: #FFFFFF;
padding-top: 13px;
}

.orderSimilarText{
    font-family: 'Poppins';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
/* identical to box height, or 150% */


color: #554D89;

}

.groupWorkingHeading{
    font-family: 'Poppins';
font-style: normal;
font-weight: 700;
font-size: 20px;
line-height: 40px;
/* identical to box height, or 200% */


color: #554D89;

}

.groupWorkingPara{
    
font-family: 'Nunito';
font-style: normal;
font-weight: 400;
font-size: 18px;
line-height: 27px;
/* or 150% */
margin-top: -5px;

color: #716C80;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/Calendex/components/Features/Features.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mEAAmE;EACnE,mBAAmB;AACrB;;;AAGA;IACI,sBAAsB;AAC1B,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,qBAAqB;AACrB,cAAc;AACd,iBAAiB;AACjB;;AAEA;IACI,sBAAsB;AAC1B,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,qCAAqC;;;AAGrC,cAAc;;AAEd;;AAEA;IACI,sBAAsB;AAC1B,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,qCAAqC;;;AAGrC,cAAc;;AAEd;;AAEA;;AAEA,qBAAqB;AACrB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,YAAY;AACZ,gBAAgB;;AAEhB,cAAc;AACd","sourcesContent":[".featuresMargin{\n  margin-top: 62px;\n}\n.calendexFeatureHeading {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 40px;\n  color: #554d89;\n}\n\n.calendexFeatureParagraph {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 27px;\n  /* or 150% */\n\n  color: #716c80;\n}\n\n.btnReadMoreBoxCoustom {\n  width: 153px;\n  height: 50px;\n  background: linear-gradient(26.57deg, #4d30ff 16.67%, #648fff 100%);\n  border-radius: 40px;\n}\n\n\n.btnReadMoreTextCoustom{\n    font-family: 'Poppins';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 16px;\nline-height: 24px;\ntext-align: center;\nletter-spacing: 0.5px;\ncolor: #FFFFFF;\npadding-top: 13px;\n}\n\n.orderSimilarText{\n    font-family: 'Poppins';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 16px;\nline-height: 24px;\n/* identical to box height, or 150% */\n\n\ncolor: #554D89;\n\n}\n\n.groupWorkingHeading{\n    font-family: 'Poppins';\nfont-style: normal;\nfont-weight: 700;\nfont-size: 20px;\nline-height: 40px;\n/* identical to box height, or 200% */\n\n\ncolor: #554D89;\n\n}\n\n.groupWorkingPara{\n    \nfont-family: 'Nunito';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 18px;\nline-height: 27px;\n/* or 150% */\nmargin-top: -5px;\n\ncolor: #716C80;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
